import React from 'react'
import PublicHeader from './PublicHeader'
import ActivityIndicator from '../ui/ActivityIndicator'
import PaintedHeadline from '../ui/PaintedHeadline'

/** Info and result pages (founder, 7 Oct 2026): a painting when one fits, the spinner while busy,
    never an icon. */
interface PublicStateShellProps {
    /** Two or three words, painted on one line as the page's picture (founder, 9 Oct 2026). */
    headline?: string
    title: string
    body?: string
    children?: React.ReactNode
    busy?: boolean
    alert?: boolean
    task?: boolean
}

const PublicStateShell: React.FC<PublicStateShellProps> = ({
    headline,
    title,
    body,
    children,
    busy = false,
    alert = false,
    task = false,
}) => (
    <div className="min-h-screen bg-[var(--dhtn-canvas)] text-[var(--dhtn-text)]">
        <PublicHeader showPreferences={task} hideStartLearningCta={task} showAccountAccess={!task} />
        <main id="main-content" data-page-width className={`dhtn-page flex items-center justify-center ${task ? 'min-h-[calc(100svh-80px)] py-12' : 'min-h-[calc(100vh-80px)] py-16'}`}>
            <section
                className={task ? `w-full ${headline ? 'max-w-3xl' : 'max-w-md'} py-6 text-center` : 'w-full max-w-xl rounded-card border-2 border-[var(--dhtn-border)] bg-transparent p-7 text-center sm:p-12'}
                aria-live="polite"
                aria-busy={busy}
                role={alert ? 'alert' : undefined}
            >
                {headline ? <>
                    <PaintedHeadline text={headline} />
                    <p className="mx-auto mt-5 max-w-md text-base font-medium leading-7 text-[var(--dhtn-text-muted)] sm:text-lg">{body ?? title}</p>
                </> : <>
                    {busy && <div className="mx-auto mb-8 flex justify-center text-[var(--dhtn-text-muted)]"><ActivityIndicator size={32} decorative /></div>}
                    <h1 className="break-words font-heading text-3xl font-semibold leading-[1.3] tracking-tight sm:text-4xl">{title}</h1>
                    {body && <p className="mx-auto mt-4 max-w-md text-base font-medium leading-7 text-[var(--dhtn-text-muted)] sm:text-lg">{body}</p>}
                </>}
                {children && <div className="mt-9">{children}</div>}
            </section>
        </main>
    </div>
)

export default PublicStateShell
